
import * as React from 'react';

//Assets
// import '../../../CoursesList/Common/Assets/course.sass';

// Interfaces
import { ICourse } from 'store/StateInterfaces';

interface IProps {
    course: ICourse;
};

const Course = (props: IProps) => {
    let course = props.course;
    let formatter = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    var start_date: string = '';
    try {
        start_date = formatter.format(Date.parse(course.course_info.start_time))
    }
    catch (e) {
        console.log(e);
    }
    // let start_date = Date.parse(course.course_info.start_time)
    // console.log(start_date)
    /*
<div className='course-box' id={`course${course.id}`} style={{ backgroundImage: 'url(' + course.image + ')' }}>
<div className='course-title' onClick={() => handleClicks(props)}>{course.title}</div>
<div className='view-course' onClick={() => handleClicks(props)}>View Course</div>
</div>
*/
    return (

        <div className="dashboard col-md-3 col-sm-4">
            <div className="dashboard-container db-student" id={`${course.id}`}>
                <div className="db-info" onClick={() => handleClicks(props)}>
                    <div className="opacity"></div>
                    <div className="db-info-label">
                        {course.enrollment_type == "O" ? "Open Course" : "Moderated Course"}
                        <span
                            // data-toggle="tooltip" 
                            title={course.enrollment_type == "O" ? "Course open to public." : "Course open only to approved students."}
                            // style={{font-size:1rem}}
                            className="material-icons icon info-icon">help_outline</span>
                    </div>
                    {/* <div className="db-userInfo"> S</div> */}
                    <div className="db-courseImageContainer">
                        {course.image ? (<img className="courseImage" src={course.image} />) : (
                            <img className="courseImage" src={"/static/img/no_image.png"} />
                        )}
                    </div>
                </div>

                <div className="db-courseLabel" title={course.title} onClick={() => handleClicks(props)}>{course.courseCode}: {course.title}</div>
                <div className="d-flex flex-row db-footerLabel">
                    <div style={{ width: '50%' }}>
                        <span className="db-courseCreated">From <span title={course.institute?.name} className="db-institute">{course.institute?.name != null ? course.institute?.name : "Other"}</span></span>
                    </div>
                    <div style={{ width: '50%' }}>
                        <span className="db-courseUpdated">Created {start_date != "" ? start_date : "01/01/2020"}</span>
                    </div>
                </div>
                {/* <div className="db-footerLabel db-offeredBy">
                    <span className=""> Offered by:</span>
                    <span className="db-institute"> {course.institute.name}</span>
                </div> */}
            </div>
        </div>


    );
}

const handleClicks = (props) => {
    window.location.href = `/courseware/course/${props.course.id}/`;
};

export default Course;
